export default __webpack_public_path__ + "static/media/b9.8fafbcf1.png";